<template>
  <div class="image-text-nav">
    <div class="tag-list" :style="tagStyle">
      <component class="tag-item-wrap" :is="tagName" :href="item.link_url" v-for="item in config.sub_entry" :key="item.key">
        <div class="tag-item" :style="itemStyle">
          <AspectRatio :ratio="ratio" v-if="config.show_method===0">
            <van-image :src="item.image_url" fit="cover" error-icon="https://files.1card1.cn/VipCloudSite/10/20200331/133aab0dfc6b4b5aa92d80b059a0d9c1.png"/>
          </AspectRatio>
          <p class="tag-name">{{item.title}}</p>
        </div>
      </component>
    </div>
  </div>
</template>

<script>
  import AspectRatio from '@/components/AspectRatio';
  import Common from "../mixins/Common";

  export default {
	name: "ImageTextNav",
	props: {},
	mixins: [Common],
	components: {AspectRatio},
	data() {
	  return {};
	},
	created() {
	},
	methods: {},
	computed: {
	  tagName() {
		return this.$IS_PREVIEW ? 'span' : 'a';
	  },
	  ratio() {
		if (!this.config.sub_entry.length) return '55%';
		const [first] = this.config.sub_entry;
		return first.image_height / first.image_width * 100 + '%';
	  },
	  tagStyle() {
	  },
	  itemStyle() {
		const {slide_setting: setting, count, sub_entry, show_method} = this.config;
		let width = 100 / sub_entry.length;
		if (setting === 1) {
		  width = 100 / (count + 0.5);
		}
		return {
		  width: width + '%',
		  color: this.config.color,
		  backgroundColor: this.config.background_color,
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .image-text-nav {
    overflow-x: auto;
    overflow-y: hidden;
    min-height: 20px;

    &::-webkit-scrollbar {
      display: none;
    }

    .tag-list {
      font-size: 0;
      white-space: nowrap;

      .tag-item {
        font-size: 14px;
        display: inline-block;
        height: 100%;
        text-align: center;

        .van-image {
          width: 100%;
          height: 100%;
        }

        .tag-name {
          padding: 5px;
          line-height: 24px;
          overflow: hidden;
          white-space: nowrap;
        }
      }
    }
  }
</style>
